import { Facility } from '@reliance/types/models/Facility';
import { InmateSubscription } from '@reliance/types/models/InmateSubscription';
import { captureException } from '@sentry/react';
import React, { useMemo, useState } from 'react';
import api from '../common/api';
import { useInmateSubscriptions } from '../hooks/InmateSubscription';
import { useNotifyTabLoading } from '../hooks/useTabLoadingReporter';
import Table from '../inmate-subscription/Table';

type FacilitySubscriptionsTabProps = {
  facility: Facility;
};

const FacilitySubscriptionsTab: React.FC<FacilitySubscriptionsTabProps> = (props) => {
  const filters = useMemo(
    () => ({
      facilityId: props.facility.id,
      active: true,
    }),
    [props.facility.id]
  );
  const subscriptions = useInmateSubscriptions(filters);
  const [, setStoppingSubscriptionId] = useState<number | null>(null);

  useNotifyTabLoading('subscriptions', subscriptions.loading);

  const onStop = (inmateSubscription: InmateSubscription) => {
    setStoppingSubscriptionId(inmateSubscription.id);

    return api
      .delete(`/inmate-subscription/${inmateSubscription.id}`)
      .then(() => subscriptions.execute())
      .catch(captureException)
      .finally(() => setStoppingSubscriptionId(null));
  };

  if (subscriptions.loading) {
    return (
      <div className="jarviswidget jarviswidget-color-blueDark">
        <div className="row">
          <div className="col-md-12">
            <h3>Loading...</h3>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="jarviswidget jarviswidget-color-blueDark">
      <div className="row">
        <div className="col-md-12">
          <Table subscriptions={subscriptions.result} onStop={onStop} />
        </div>
      </div>
    </div>
  );
};

export const facilitySubscriptionsTabMeta = {
  heading: 'Subscriptions',
  style: 'fas fa-fw fa-lg fa-retweet',
  permissions: undefined as string[] | undefined,
};

export default FacilitySubscriptionsTab;
